import React from 'react';
import { TextField, withStyles } from '@material-ui/core';

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
});

const InfoField = (props) =>
  <TextField
    id="outlined-disabled"
    label={props.label}
    defaultValue={props.children}
    className={props.classes.textField}
    margin="normal"
    variant="outlined"
    fullWidth
    InputLabelProps={{
      shrink: true,
    }}
  />
  
export default withStyles(styles)(InfoField);